import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import ImageGallery from "../../components/ImageGallery";

const ProjectDetails = (props) => {
  const { open, setOpen, handleOpen, project } = props
  const [imgSrc,setImgSrc] = useState(project?.image[0])
  const [activeIdx,setActiveIdx] = useState(0)
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    autoplay: false,
    // autoplaySpeed: 2000,
    cssEase: "linear",
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          // dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          // initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  };
  const handleSelectImg = (img,idx) => {
     setImgSrc(img)
     setActiveIdx(idx)
  }
  

  return (
    <>
      <Modal
        open={open}
        onClose={handleOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box sx={style}>
          <div className="d-flex flex-row-reverse ">
            <IconButton onClick={handleOpen}>
              <CloseIcon />
            </IconButton>
          </div>
          <h3 className="text-center p-4">{project?.name}</h3>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {/* <ImageZoom imageSrc={project?.image[0]} /> */}
          </Box>
          <Box>
            <div className="row container">

              <div className="text-center p-4">

                {/* <Box sx={{display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>

                <Box sx={{width:"90%"}}>
                  <Box component="img" src={imgSrc} sx={{ maxHeight: { xs: "200px", sm: "300px",md:"400px" } }}></Box>
                </Box>
                <Box sx={{ width: "100%",padding:"10px"}}>

                  <Slider {...settings}>
                    {
                      project?.image?.map((data, idx) => {
                        return (
                          <div key={idx} className=" p-2">
                  
                            <Box
                              onClick={()=> handleSelectImg(data,idx)}
                              sx={{
                                // background: 'linear-gradient(90deg, #2d9cdb, #56ccf2)',
                                // minHeight: '100vh',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 1,
                                position: 'relative',
                                overflow: 'hidden',
                                height:"100px",
                                backgroundColor:`${activeIdx === idx ? "blue" : "white"}`,
                                // "&:hover": {
                                //   backgroundColor: "gray",
                                //   color: "white",
                                // },
                              }}
                            >
                            <img src={data} height="100%"/>
          
                            </Box>

                          </div>
                        )
                      })
                    }
                  </Slider>
                </Box>
                </Box> */}
                <ImageGallery imageList={project?.image}/>
              </div>
              {/* <div className="col-md-6 container p-4">
                   <Box>
                    <table width="70%">
                   
                      <tbody>
                         <tr>
                          <td>
                            <h4>Client Name:</h4>
                          </td>
                          <td>
                            <h4>Mohamed</h4>
                          </td>
                         </tr>
                         <tr>
                          <td>
                            <h4>Size:</h4>
                          </td>
                          <td>
                            <h4>100 Sq Feet</h4>
                          </td>
                         </tr>
                         <tr>
                          <td>
                            <h4>Category:</h4>
                          </td>
                          <td>
                            <h4>Residential</h4>
                          </td>
                         </tr>
                         <tr>
                          <td>
                            <h4>Area:</h4>
                          </td>
                          <td>
                            <h4>Melepalaym</h4>
                          </td>
                         </tr>
                      </tbody>
                    </table>

                   </Box>
              </div> */}
            </div>

          </Box>
          {/* <Box className="p-4">
            <p>
              {project?.description}
            </p>
          </Box> */}
        </Box>

      </Modal>
    </>
  )
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  // p: 4,
  scroll: "auto",
  maxHeight: "95vh",
  overflowY: "auto",
};

export default ProjectDetails;